import { getClientAssessments } from "api/customers";
import { CLIENT_ASSESSMENTS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { useQuery } from "react-query";

export const useGetClientAssessments = (clientId) => {
  const { data, isLoading, ...rest } = useQuery(
    [CLIENT_ASSESSMENTS, clientId],
    () => getClientAssessments(clientId),
    {
      enabled: !!clientId,
      refetchOnWindowFocus: false,
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return {
    clientAssessments: data?.data || null,
    assessmentsLoading: isLoading,
    ...rest,
  };
};
